<div class="mobile-item-card-channel-stores-container"
  [ngStyle]="{'border': searchResult ? '0.5px solid var(--neutral-20)' : '0px' }">
  <div class="channelStore-item-card-image"
    [ngClass]="{'disabled-img': storeData.currentStatus !== storeStatusFlag.Open}">
    <img [src]="storeData | storeImage : attrCode.OUTLETIMG" onerror="this.src='assets/generalImage/broken_image.svg'"
      alt="image" loading="lazy" />

    <ng-template [ngIf]="storeData.currentStatus !== storeStatusFlag.Open">
      <span class="item-status" *ngIf="storeData.currentStatus === storeStatusFlag.Closed">
        {{'label.status.closed' | translate}}
      </span>
      <span class="item-status" *ngIf="storeData.currentStatus === storeStatusFlag.OutofCoverage">
        {{'label.status.out.of.coverage' | translate}}
      </span>
      <span class="item-status" *ngIf="storeData.currentStatus === storeStatusFlag.TempClosed">
        {{'label.status.temporarily.closed' | translate}}
      </span>
      <span class="item-status" *ngIf="storeData.currentStatus === storeStatusFlag.Offline">
        {{'label.status.offline' | translate}}
      </span>
    </ng-template>
  </div>

  <div class="channelStore-item-card-detail">
    <div class="item-card-info">
      <span>{{storeData.locDesc}}</span>
      <div class="item-card-sub-info">
        <div class="itemCard-ordertype" *ngIf="storeData.currentOrderType">
          <i class="{{storeData.currentOrderType | orderTypeIcon}}"></i>
          <span *ngIf="storeData.currentOrderType == orderTypeFlag.All">{{"label.all" | translate}}</span>
          <span *ngIf="storeData.currentOrderType == orderTypeFlag.Pickup">{{"label.pick.up" | translate}}</span>
          <span *ngIf="storeData.currentOrderType == orderTypeFlag.DineIn">{{"label.dine.in" | translate}}</span>
          <span *ngIf="storeData.currentOrderType == orderTypeFlag.Delivery">{{"label.delivery" | translate}}</span>
        </div>

        <div class="itemCard-distance" *ngIf="storeData.distance">
          <i class="icon-shop-outlet"></i>
          <span>{{"label.distance" | translate: { distance: storeData.distance | number : '.1-1' } }}</span>
        </div>

        <div class="itemCard-rate" *ngIf="storeData.ratingAverage ">
          <i class="icon-rate-star"></i>
          <span>{{storeData.ratingAverage | number : '.1-1'}}</span>
        </div>
        <span class="itemCard-deliveryFees"
          *ngIf="storeData.currentOrderType == orderTypeFlag.Delivery">{{storeData.deliveryFee ? (storeData.deliveryFee
          | currency:
          currency.currCode : 'symbol-narrow') : 'label.free.delivery' | translate }}</span>
      </div>
      <span class="itemCard-storeCatg truncateText">{{storeData.storeCatgAttrs ?
        (getStoreAttrDesc(storeData.storeCatgAttrs)) : ('label.other' | translate) }}</span>
    </div>

    <div class="itemCard-moreImage" *ngIf="showMoreImages && storeAttrImages.length > 0">
      <div class="image-container" *ngFor="let storeAttr of storeAttrImages; let i = index">
        <img *ngIf="storeAttr.attrData.length > 0" src="{{storeAttr.attrData}}"
          onerror="this.src='assets/generalImage/broken_image.svg'" alt="store image" loading="lazy" />
      </div>
    </div>

    <div class="itemCard-promo" *ngIf="storeData.promoText && storeData.promoText != 'NULL'">
      <i class="icon-discount"></i>
      <span>{{storeData.promoText}}</span>
    </div>

    <ng-template [ngIf]="storeData.currentStatus !== storeStatusFlag.Open">
      <div class="itemCard-status">
        <i class="icon-calendar-time"></i>
        <span *ngIf="storeData.currentStatus === storeStatusFlag.Closed && !isStoreClosedPreOrder">
          {{'label.status.closed' | translate}}
        </span>
        <span *ngIf="storeData.currentStatus === storeStatusFlag.Closed && isStoreClosedPreOrder"
          [innerHtml]="'label.pre.order.from' | translate: { time : '<span class=\'preorder-time\'>' + (storeData.currentStatus | nextAvailableTime : storeData) + '</span>' } | safeHtml">
        </span>
        <span *ngIf="storeData.currentStatus === storeStatusFlag.OutofCoverage">
          {{'label.status.out.of.coverage' | translate}}
        </span>
        <span *ngIf="storeData.currentStatus === storeStatusFlag.TempClosed">
          {{'label.status.temporarily.closed' | translate}}
        </span>
        <span *ngIf="storeData.currentStatus === storeStatusFlag.Offline">
          {{'label.status.offline' | translate}}
        </span>
      </div>
    </ng-template>

    <span class="itemCard-nearByStore" *ngIf="storeData.otherStores.length > 0 && showStoreNearBy"
      (click)="onClickOtherStore(storeData); $event.stopPropagation()">{{'number.of.nearby.store' | translate: {count:
      storeData.otherStores.length} }}</span>
  </div>
</div>